import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import berita from '../views/Berita/berita.vue'
import isiBerita from '../views/Berita/isiBerita.vue'
import bukuProfil from '../views/Profil/bukuProfil.vue'
import dokterRSUD from '../views/Profil/dokterRSUD.vue'
import StrukturOrganisasi from '../views/Profil/StrukturOrganisasi.vue'
import tentangKami from '../views/Profil/tentangKami.vue'
import TugasPokok from '../views/Profil/TugasPokok.vue'
import VisiMisi from '../views/Profil/VisiMisi.vue'
import alurPelayanan from '../views/fasilitasPelayanan/alurPelayanan.vue'
import pelayananKesehatan from '../views/fasilitasPelayanan/pelayananKesehatan.vue'
import saranaPrasarana from '../views/fasilitasPelayanan/saranaPrasarana.vue'
import standarPelayanan from '../views/fasilitasPelayanan/standarPelayanan.vue'
import data from '../views/dokumen/data.vue'
import dokumenPerencanaan from '../views/dokumen/dokumenPerencanaan.vue'
import foto from '../views/galeri/foto.vue'
import video from '../views/galeri/video.vue'
import perpustakaanDigital from '../views/perpustakaanDigital.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/berita',
    name: 'berita',
    component: berita
  },
  {
    path: '/isiBerita',
    name: 'isiBerita',
    component: isiBerita
  },
  {
    path: '/bukuProfil',
    name: 'bukuProfil',
    component: bukuProfil
  },
  {
    path: '/dokterRSUD',
    name: 'dokterRSUD',
    component: dokterRSUD
  },
  {
    path: '/StrukturOrganisasi',
    name: 'StrukturOrganisasi',
    component: StrukturOrganisasi
  },
  {
    path: '/tentangKami',
    name: 'tentangKami',
    component: tentangKami
  },
  {
    path: '/TugasPokok',
    name: 'TugasPokok',
    component: TugasPokok
  },
  {
    path: '/VisiMisi',
    name: 'VisiMisi',
    component: VisiMisi
  },
  {
    path: '/alurPelayanan',
    name: 'alurPelayanan',
    component: alurPelayanan
  },
  {
    path: '/pelayananKesehatan',
    name: 'pelayananKesehatan',
    component: pelayananKesehatan
  },
  {
    path: '/saranaPrasarana',
    name: 'saranaPrasarana',
    component: saranaPrasarana
  },
  {
    path: '/standarPelayanan',
    name: 'standarPelayanan',
    component: standarPelayanan
  },
  {
    path: '/data',
    name: 'data',
    component: data
  },
  {
    path: '/dokumenPerencanaan',
    name: 'dokumenPerencanaan',
    component: dokumenPerencanaan
  },
  {
    path: '/foto',
    name: 'foto',
    component: foto
  },
  {
    path: '/video',
    name: 'video',
    component: video
  },
  {
    path: '/perpustakaanDigital',
    name: 'perpustakaanDigital',
    component: perpustakaanDigital
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
